import { DISPLAY_DIGITS_AFTER_ZERO } from '../constants/base';

export const formatBalance = (amount: number, decimals: number): number => {
  const formatted = amount.toFixed(decimals);
  const parts = formatted.split('.');
  if (parts.length === 2) {
    return Number(parts[0] + '.' + parts[1].slice(0, DISPLAY_DIGITS_AFTER_ZERO));
  } else {
    return Number(formatted);
  }
};

export const displayFullAmount = (amount: number, decimals: number) =>
  amount.toFixed(decimals).replace(/\.?0+$/, '');
